import { useDispatch } from "react-redux";
import { ImportModal } from "../ImportModal";
import { TabHeader } from "../TabHeader/TabHeader";
import { setCurrentlyOpenModal } from "../../redux";
import { modals } from "../../util/constants";
import { Button } from "antd";

export const AdvancedTab = () => {
  const dispatch = useDispatch();
  return (
    <div
      style={{
        height: "calc(100% - var(--hse-line-height))",
        maxHeight: "calc(100% - var(--hse-line-height))",
        overflowX: "hidden",
        padding: "8px 32px 20px 32px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <TabHeader>Advanced</TabHeader>
      <Button onClick={() => dispatch(setCurrentlyOpenModal(modals.import))}>
        Import ...
      </Button>
      <ImportModal />
    </div>
  );
};
